'use client';
import { event_button_click } from '@/utils/gtm';

import { useTranslations } from 'next-intl';
import useLogout from '@/hooks/useLogout';
import UserIcon from '@/components/ui/icons/user-icon';
import ArrowIcon from '@/components/ui/icons/arrow-icon';
import { signIn, useSession } from 'next-auth/react';
import NextLink from '@/components/next-link';
import { usePathname } from '@/i18n/navigation';

const Account = () => {
  const t = useTranslations('common');
  const logOut = useLogout();
  const pathname = usePathname()
  const { data: session } = useSession();

  return (
    <div className='hidden items-center gap-2.5 lg:flex'>
      <div className='flex flex-col'>
        <div className='group relative flex items-center gap-1'>
          <p className='flex cursor-pointer items-center gap-3 font-bold text-[#222]'>
            {!session?.user ? (
              <button
                onClick={() => {
                  event_button_click({
                    button_name: 'Login And Register',
                    button_destination: '/login',
                    button_location: 'header',
                  });
                  signIn(null, { callbackUrl: pathname || '/' });
                }}
                className='flex items-center gap-3 text-[15.8px]'
              >
                {t('Login and Register')} <UserIcon className='size-2.5 lg:size-3.5' />
              </button>
            ) : (
              <>
                {' '}
                {session?.user?.firstname}
                <ArrowIcon className='size-2.5 lg:size-3.5' />
              </>
            )}
          </p>

          {session ? (
            <div className='absolute top-6 z-50 hidden w-48 flex-col overflow-hidden rounded-md border border-border bg-white shadow-md group-hover:flex ltr:start-[35%] ltr:-translate-x-1/2 rtl:-start-10 rtl:translate-x-[1/4]'>
              <div className='flex flex-col'>
                <div className='border-b-border flex flex-col border-b p-2 text-sm'>
                  <h6 className='font-medium text-gray-700'>
                    {t('Welcome Back')}
                  </h6>
                  <p className='font-bold text-black'>
                    {session?.user?.firstname || ''}{' '}
                  </p>
                </div>
                <div className='flex flex-col text-[15px]'>
                  <NextLink
                    href='/user'
                    onClick={() =>
                      event_button_click({
                        button_name: 'My Account',
                        button_destination: '/user',
                        button_location: 'header',
                      })
                    }
                    className='flex max-h-9 min-h-9 cursor-pointer items-center px-2 font-semibold text-gray-700 hover:bg-slate-100'
                  >
                    {t('My_Account')}
                  </NextLink>
                  <NextLink
                    href='/user/orders'
                    onClick={() =>
                      event_button_click({
                        button_name: 'My Orders',
                        button_destination: '/user/orders',
                        button_location: 'header',
                      })
                    }
                    className='flex max-h-9 min-h-9 cursor-pointer items-center px-2 font-semibold text-gray-700 hover:bg-slate-100'
                  >
                    {t('My Orders')}
                  </NextLink>
                  <button
                    onClick={logOut}
                    className='flex max-h-9 min-h-9 cursor-pointer items-center px-2 text-start font-semibold text-gray-700 hover:bg-slate-100'
                  >
                    {t('Log Out')}
                  </button>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Account;
